var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":"box","type":"text"}}),_c('button',{on:{"click":function($event){return _vm.ll()}}},[_vm._v("还原")])])}
var staticRenderFns = []

export { render, staticRenderFns }